/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CallingIdentity } from './CallingIdentity';
import {
    CallingIdentityFromJSON,
    CallingIdentityFromJSONTyped,
    CallingIdentityToJSON,
} from './CallingIdentity';
import type { ContactImportStatus } from './ContactImportStatus';
import {
    ContactImportStatusFromJSON,
    ContactImportStatusFromJSONTyped,
    ContactImportStatusToJSON,
} from './ContactImportStatus';
import type { QaCSVMetadata } from './QaCSVMetadata';
import {
    QaCSVMetadataFromJSON,
    QaCSVMetadataFromJSONTyped,
    QaCSVMetadataToJSON,
} from './QaCSVMetadata';

/**
 * A contact import job
 * @export
 * @interface ContactImport
 */
export interface ContactImport {
    /**
     * Name of the import
     * @type {string}
     * @memberof ContactImport
     */
    name: string;
    /**
     * The S3 bucket from which contacts should be imported
     * @type {string}
     * @memberof ContactImport
     */
    bucket: string;
    /**
     * ID of the prompt revision for this import
     * @type {string}
     * @memberof ContactImport
     */
    promptRevisionId: string;
    /**
     * Optional prefix within the bucket from which contacts should be imported
     * When omitted, all contacts from the bucket will be used
     * @type {string}
     * @memberof ContactImport
     */
    key?: string;
    /**
     * The language of the imported contacts
     * @type {string}
     * @memberof ContactImport
     */
    language?: string;
    /**
     * The maximum number of speakers in the imported contacts
     * @type {number}
     * @memberof ContactImport
     */
    maxSpeakers?: number;
    /**
     * Whether to translate the imported contacts to English
     * @type {boolean}
     * @memberof ContactImport
     */
    translateToEnglish?: boolean;
    /**
     * The time at which the resource was created
     * @type {number}
     * @memberof ContactImport
     */
    createdAt: number;
    /**
     * The time of the most recent update
     * @type {number}
     * @memberof ContactImport
     */
    updatedAt: number;
    /**
     * 
     * @type {CallingIdentity}
     * @memberof ContactImport
     */
    createdBy: CallingIdentity;
    /**
     * 
     * @type {CallingIdentity}
     * @memberof ContactImport
     */
    updatedBy: CallingIdentity;
    /**
     * ID of the job
     * @type {string}
     * @memberof ContactImport
     */
    contactImportId: string;
    /**
     * 
     * @type {ContactImportStatus}
     * @memberof ContactImport
     */
    status: ContactImportStatus;
    /**
     * Details about the status, if any
     * @type {string}
     * @memberof ContactImport
     */
    statusDetails?: string;
    /**
     * Count of all contacts to process
     * @type {number}
     * @memberof ContactImport
     */
    totalCount?: number;
    /**
     * Count of processed contacts
     * @type {number}
     * @memberof ContactImport
     */
    processedCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ContactImport
     */
    totalNeedProcessing?: number;
    /**
     * 
     * @type {QaCSVMetadata}
     * @memberof ContactImport
     */
    qaCSVMetadata?: QaCSVMetadata;
    /**
     * Count of failed contacts
     * @type {number}
     * @memberof ContactImport
     */
    failedCount?: number;
}


/**
 * Check if a given object implements the ContactImport interface.
 */
export function instanceOfContactImport(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "bucket" in value;
    isInstance = isInstance && "promptRevisionId" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "updatedAt" in value;
    isInstance = isInstance && "createdBy" in value;
    isInstance = isInstance && "updatedBy" in value;
    isInstance = isInstance && "contactImportId" in value;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function ContactImportFromJSON(json: any): ContactImport {
    return ContactImportFromJSONTyped(json, false);
}

export function ContactImportFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactImport {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'bucket': json['bucket'],
        'promptRevisionId': json['promptRevisionId'],
        'key': !exists(json, 'key') ? undefined : json['key'],
        'language': !exists(json, 'language') ? undefined : json['language'],
        'maxSpeakers': !exists(json, 'maxSpeakers') ? undefined : json['maxSpeakers'],
        'translateToEnglish': !exists(json, 'translateToEnglish') ? undefined : json['translateToEnglish'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'createdBy': CallingIdentityFromJSON(json['createdBy']),
        'updatedBy': CallingIdentityFromJSON(json['updatedBy']),
        'contactImportId': json['contactImportId'],
        'status': ContactImportStatusFromJSON(json['status']),
        'statusDetails': !exists(json, 'statusDetails') ? undefined : json['statusDetails'],
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'processedCount': !exists(json, 'processedCount') ? undefined : json['processedCount'],
        'totalNeedProcessing': !exists(json, 'totalNeedProcessing') ? undefined : json['totalNeedProcessing'],
        'qaCSVMetadata': !exists(json, 'qaCSVMetadata') ? undefined : QaCSVMetadataFromJSON(json['qaCSVMetadata']),
        'failedCount': !exists(json, 'failedCount') ? undefined : json['failedCount'],
    };
}

export function ContactImportToJSON(value?: ContactImport | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'bucket': value.bucket,
        'promptRevisionId': value.promptRevisionId,
        'key': value.key,
        'language': value.language,
        'maxSpeakers': value.maxSpeakers,
        'translateToEnglish': value.translateToEnglish,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'createdBy': CallingIdentityToJSON(value.createdBy),
        'updatedBy': CallingIdentityToJSON(value.updatedBy),
        'contactImportId': value.contactImportId,
        'status': ContactImportStatusToJSON(value.status),
        'statusDetails': value.statusDetails,
        'totalCount': value.totalCount,
        'processedCount': value.processedCount,
        'totalNeedProcessing': value.totalNeedProcessing,
        'qaCSVMetadata': QaCSVMetadataToJSON(value.qaCSVMetadata),
        'failedCount': value.failedCount,
    };
}

